require('easy-autocomplete')
class autocomplete {
  __constructor() {
    this.$input = document.querySelector('#q')
  }

  init() {
    this.__constructor()
    if(!this.$input) return

    let $parent = this.$input.closest('.input-field')
    let url = this.$input.getAttribute('data-url-to-fetch')

    var options = {
      url: function(query) {
        return url + query;
      },
      getValue: 'title',
      requestDelay: 300
    };

    $(this.$input).easyAutocomplete(options);
  }
}
export default autocomplete
